import { render, staticRenderFns } from "./CProgressBar.vue?vue&type=template&id=08fb056e&"
import script from "./CProgressBar.vue?vue&type=script&lang=js&"
export * from "./CProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports